module.exports = __webpack_public_path__ + "static/url-a40308b46fef7b12ed1e747cb146384f.png";